// Some of the dict phrases like AcceptedOdds, stake and KeepSelections will be
// used for yourBet for live and they have to be check if such phrase already exist
export type BaseDict = {
    PlaceBets: string,
    Danger: string,
    AcceptOdds: string,
    AcceptStake: string,
    AcceptAll: string,
    BetsAccepted: string,
    KeepSelections: string,
    Clear: string,
    EmtyMsg: string,
    SelectionLabel: string,
    Return: string,
    TicketNumber: string,
    Stake: string,
    RetainSelections: string,
    OddsChanged: string,
    StakeChanged: string
}
export const BaseDict: BaseDict = {
    PlaceBets: "Place Your Bet",
    Danger: "Suspended",
    RetainSelections: "Retain Selections",
    AcceptOdds: "Accept New Odds",
    AcceptStake: "Accept New Stake",
    AcceptAll: "Accept Odds & Stake",
    //it's added BetsAccepted not BetAccepted because the second one contains "ticket" word
    BetsAccepted: "Your bet was accepted",
    KeepSelections: "Keep Selections",
    Clear: "Clear all",
    EmtyMsg: "Choose Your Selections",
    SelectionLabel: "Selections",
    Return: "Return",
    TicketNumber: "Ticket Number",
    Stake: "Stake",
    OddsChanged: "Odds changed",
    StakeChanged: "Stake changed"
}